import { TotpMultiFactorInfo } from 'firebase/auth';
import * as React from 'react';
import { SelectionCard } from '../../../../shared/SelectionCard';

export interface ITotpHintProps {
  hint: TotpMultiFactorInfo;
  onClick: (value: TotpMultiFactorInfo) => void;
  selected: boolean;
  animationDelay?: number;
}

export const TotpHint = React.memo(
  (props: ITotpHintProps): React.ReactElement => {
    const handleClick = React.useCallback((): void => {
      props.onClick(props.hint);
    }, [props.onClick, props.hint]);

    return (
      <SelectionCard
        selected={props.selected}
        onClick={handleClick}
        icon='verified_user'
        title={props.hint.displayName ?? 'Google Authenticator'}
        description='Authenticator app'
        animationDelay={props.animationDelay}
      />
    );
  },
  (
    prevProps: Readonly<ITotpHintProps>,
    nextProps: Readonly<ITotpHintProps>
  ): boolean => {
    return (
      prevProps.selected === nextProps.selected &&
      prevProps.hint.uid === nextProps.hint.uid &&
      prevProps.onClick === nextProps.onClick &&
      prevProps.animationDelay === nextProps.animationDelay
    );
  }
);

TotpHint.displayName = 'TotpHint';
